import * as React from 'react';
import { FunctionComponent } from 'react';

//MUI
import Grid, { GridProps } from '@mui/material/Grid';

const GridItem: FunctionComponent<GridProps> = (props) => {
  return <Grid {...props}>{props.children}</Grid>;
};

export default GridItem;
